<template>
  <div v-if="layoutStore.modalName" class="modal">
    <div class="modal__inner block">
      <div class="modal__close" @click="layoutStore.closeModal()">x</div>

      <div class="modal__content">
        <component :is="modalName" v-bind="layoutStore.modalData" />
      </div>
    </div>
  </div>
</template>

<script setup>
import ModalSelect from '@/components/ModalSelect.vue'

import { computed, defineAsyncComponent } from 'vue'
import { useLayoutStore } from '@/store'

const layoutStore = useLayoutStore()

const modalName = computed(() => defineAsyncComponent(() => import(`@/components/${layoutStore.modalName}`)))
</script>

<style lang="sass">
.modal
  position: fixed
  top: 0
  left: 0
  z-index: 1
  height: 100vh
  width: 100vw
  background-color: #0000008c
  display: flex
  justify-content: center
  align-items: center
  animation: fadeIn 0.5s ease

  &__inner
    position: relative
    max-width: 484px
    width: 100%
    padding: 12px 16px
    margin: 0 12px
    border-radius: 8px
    background-color: #661b50

  &__content
    line-height: 20px
    font-size: 18px
    color: white
    max-height: 50vh
    overflow: auto
    padding-right: 12px

    span
      color: #21b8ff

  &__close
    position: absolute
    right: -22px
    top: -16px
    background-color: white
    color: black
    padding: 0 6px
    border-radius: 6px
    margin: 6px 12px
    cursor: pointer
    font-size: 24px
    height: 24px
    user-select: none

</style>